
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOAD_USER = "LOAD_USER";
export const IS_USER_LOGGED = "LOAD_USER";

// Alerts
export const SHOW_ALERT = 'SHOW_ALERT';
export const CLEAR_ALERT = 'CLEAR_ALERT';

// Control
export const SET_SHOPPINGLIST_SELECTED = 'SET_SHOPPINGLIST_SELECTED';
export const SET_SHOPPINGLIST = 'SET_SHOPPINGLIST';
export const SET_LOADING = 'SET_LOADING';
export const SET_REQUEST_LOADING = 'SET_REQUEST_LOADING';
export const SET_USER_LOGGED = 'SET_USER_LOGGED';
export const SET_APP_INIT = 'SET_APP_INIT';


// shoppping lists and items
export const UPDATE_SHOPPINGLISTS = 'UPDATE_SHOPPINGLISTS';

export const ADD_NEW_ITEM = 'ADD_NEW_ITEM';
export const GET_ITEMS = 'GET_ITEMS'; 
export const REMOVE_ITEM = 'REMOVE_ITEM'; 
export const ITEM_LOADING = 'ITEM_LOADING'; 